import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

const EventFunction = () => {
  // Filenames of images inside public/assets
  const imageFilenames = [
    "1 (1).jpg", "2 (1).jpg", "3.jpg", "4.jpg", "5.jpg", "6.jpg",
    "7.jpg", "8.jpg", "9.jpg", "10.jpg", "11.jpg", "12.jpg"
  ];

  // Map filenames to public folder paths
  const images = imageFilenames.map((filename) => `/assets/${filename}`);

  return (
    <>
      <Navbar />
      <section className="py-12 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-10">
            Events & Functions
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {images.map((src, index) => (
              <div key={index} className="overflow-hidden rounded-xl shadow-lg">
                <img
                  src={src}
                  alt={`Function ${index + 1}`}
                  className="w-full h-[300px] object-cover cursor-pointer transform hover:scale-105 transition duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default EventFunction;
